import { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const CaseWorkerRoleModal = ({
  show,
  handleClose,
  caseType,
  caseWorkerRoles,
  onRoleChange,
  handleSave,
  modalTitle = "Select the Case Worker Roles for Case Workers 1-6 on each Case Type in",
  saveButtonText = "Save",
}) => {
  const [selectedRoles, setSelectedRoles] = useState([]);

  useEffect(() => {
    if (caseType) {
      setSelectedRoles([
        {
          id: caseType.user_case_type_1?.id || 0,
          name: caseType.user_case_type_1?.name || "",
        },
        {
          id: caseType.user_case_type_2?.id || 0,
          name: caseType.user_case_type_2?.name || "",
        },
        {
          id: caseType.user_case_type_3?.id || 0,
          name: caseType.user_case_type_3?.name || "",
        },
        {
          id: caseType.user_case_type_4?.id || 0,
          name: caseType.user_case_type_4?.name || "",
        },
        {
          id: caseType.user_case_type_5?.id || 0,
          name: caseType.user_case_type_5?.name || "",
        },
        {
          id: caseType.user_case_type_6?.id || 0,
          name: caseType.user_case_type_6?.name || "",
        },
      ]);
    }
  }, [caseType]);

  const handleRoleChangeLocal = (roleId, roleName, index) => {
    const updatedRoles = [...selectedRoles];
    updatedRoles[index] = { id: parseInt(roleId, 10), name: roleName };
    setSelectedRoles(updatedRoles);
    onRoleChange(updatedRoles);
  };

  const saveChanges = () => {
    const updatedData = {
      id: caseType.id,
      user_case_type_1: selectedRoles[0],
      user_case_type_2: selectedRoles[1],
      user_case_type_3: selectedRoles[2],
      user_case_type_4: selectedRoles[3],
      user_case_type_5: selectedRoles[4],
      user_case_type_6: selectedRoles[5],
    };
    handleSave(updatedData);
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      dialogClassName="max-800 modal-dialog-centered "
      contentClassName="custom-modal-new-provider"
    >
      <Modal.Header
        style={{
          borderBottom: "0px",
        }}
        className="text-center height-25 p-0 bg-primary popup-heading-color justify-content-center"
      >
        <Modal.Title
          className="mx-auto height-25 font-weight-semibold text-uppercase popup-heading-color d-flex align-items-center"
          id="modal_title"
          style={{ fontSize: "14px", fontWeight: "600" }}
        >
          {modalTitle}
          {` ${caseType?.for_case_type.case_type_category?.name}`}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body
        className=""
        style={{
          padding: "5px 5px",
        }}
      >
        <Form className="w-100">
          {Array.from({ length: 3 }).map((_, index) => (
            <div key={index} className="m-b-5 d-flex justify-content-center">
              {/* First role dropdown */}
              <div
                className="d-flex align-items-center custom-select-new-provider justify-content-center"
                style={{ flex: 1 }}
              >
                <Form.Label
                  style={{
                    color: "var(--primary-25)",
                    fontWeight: "600",
                    minWidth: "138px",
                  }}
                  className="m-b-0 text-nowrap  d-flex align-items-center m-r-5"
                >{`Case Worker Role ${index + 1}: `}</Form.Label>
                <Form.Control
                  className="height-25 p-l-5 p-r-5 py-0"
                  as="select"
                  value={selectedRoles[index]?.id || ""}
                  onChange={(e) =>
                    handleRoleChangeLocal(
                      e.target.value,
                      e.target.options[e.target.selectedIndex].text,
                      index
                    )
                  }
                >
                  <option value="" disabled>
                    Select Role
                  </option>
                  {caseWorkerRoles?.map((role) => (
                    <option key={role.id} value={role.id}>
                      {role.name}
                    </option>
                  ))}
                </Form.Control>
              </div>

              {/* Second role dropdown */}
              <div
                className="d-flex align-items-center custom-select-new-provider justify-content-center"
                style={{ flex: 1, marginLeft: "10px" }}
              >
                <Form.Label
                  style={{
                    color: "var(--primary-25)",
                    fontWeight: "600",
                  }}
                  className="m-b-0 text-nowrap d-flex align-items-center m-r-5"
                >{`Case Worker Role ${index + 4}: `}</Form.Label>
                <Form.Control
                  className="height-25 p-l-5 p-r-5 py-0"
                  as="select"
                  value={selectedRoles[index + 3]?.id || ""}
                  onChange={(e) =>
                    handleRoleChangeLocal(
                      e.target.value,
                      e.target.options[e.target.selectedIndex].text,
                      index + 3
                    )
                  }
                >
                  <option value="" disabled>
                    Select Role
                  </option>
                  {caseWorkerRoles?.map((role) => (
                    <option key={role.id} value={role.id}>
                      {role.name}
                    </option>
                  ))}
                </Form.Control>
              </div>
            </div>
          ))}
        </Form>
        <div className="d-flex justify-content-between custom-margin-top">
          <Button
            variant="secondary"
            className="height-25"
            style={{ padding: "0px 12px" }}
            onClick={handleClose}
          >
            Close
          </Button>

          <Button
            type="submit"
            variant="success"
            className="m-l-5 bg-success height-25"
            style={{ padding: "0px 12px" }}
            onClick={saveChanges}
          >
            {saveButtonText}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CaseWorkerRoleModal;
